var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C7.95986 0 3.85938 4.10048 3.85938 9.14062C3.85938 10.8435 4.33108 12.5054 5.22382 13.9472L12.4797 25.6399C12.6187 25.8639 12.8636 26 13.1269 26C13.1289 26 13.1309 26 13.1329 26C13.3986 25.9979 13.644 25.8576 13.7804 25.6297L20.8513 13.8237C21.6948 12.4124 22.1406 10.793 22.1406 9.14062C22.1406 4.10048 18.0401 0 13 0ZM19.544 13.0415L13.1154 23.7751L6.51864 13.1445C5.77555 11.9445 5.37266 10.56 5.37266 9.14062C5.37266 4.94051 8.79988 1.51328 13 1.51328C17.2001 1.51328 20.6223 4.94051 20.6223 9.14062C20.6223 10.5179 20.2459 11.867 19.544 13.0415Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.57031C10.4799 4.57031 8.42969 6.62055 8.42969 9.14062C8.42969 11.6446 10.4466 13.7109 13 13.7109C15.5849 13.7109 17.5703 11.6171 17.5703 9.14062C17.5703 6.62055 15.5201 4.57031 13 4.57031ZM13 12.1977C11.3112 12.1977 9.94297 10.8249 9.94297 9.14062C9.94297 7.46058 11.32 6.08359 13 6.08359C14.68 6.08359 16.052 7.46058 16.052 9.14062C16.052 10.8003 14.7156 12.1977 13 12.1977Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-Icon.51b1950c276ade824cb064b927990093.svg";
export { ForwardRef as ReactComponent };